import React, { PureComponent, Fragment } from 'react';

import { I18n } from 'components/translate';
import { CommunityService } from 'modules/community';
import PropTypes from 'prop-types';

import './CommentDetailHeader.scss';

export default class CommentDetailHeader extends PureComponent {
  static propTypes = {
    item: PropTypes.shape({
      commentClass: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string
      }),
      commentDate: PropTypes.string,
      content: PropTypes.string,
      id: PropTypes.string,
      lastAction: PropTypes.string,
      page: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        module: PropTypes.string
      }),
      status: PropTypes.string,
      type: PropTypes.string,
      user: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        email: PropTypes.string
      })
    })
  };

  viewAsProducerIsAllowed = CommunityService.viewAsProducerIsAllowed;

  render() {
    const { item } = this.props;

    return (
      <Fragment>
        <div className="comment-list__history__comment-detail__header">
          <div className="comment-list__history__comment-detail__header__title">
            <div className="comment-list__history__comment-detail__header__title__module">
              {item.page.module}
            </div>

            <div className="comment-list__history__comment-detail__header__title__class">
              {item.page.name}
            </div>
          </div>

          {this.viewAsProducerIsAllowed && (
            <div className="comment-list__history__comment-detail__header__user-historic">
              <a
                className="comment-list__context-modal__historic-title__user-historic"
                onClick={() => CommunityService.redirectClassAcademy(item)}
              >
                <I18n label="community.see_all_topic_comments" />
              </a>
            </div>
          )}
        </div>

        <hr className="comment-list__history__comment-detail__divisor" />
      </Fragment>
    );
  }
}
